import React, { useEffect, useState } from "react";
import Alert from "react-bootstrap/Alert";
import apiService from "../services/api.service";
import "./stats.css";

const extractCount = (value) => {
  if (value == null) return 0;
  if (typeof value === "number") return value;
  if (typeof value.count === "number") return value.count;
  if (Array.isArray(value)) return value[0] ?? 0;
  if (typeof value[0] === "number") return value[0];
  return 0;
};

const normalizeProvince = (row) => ({
  name: row.provincia ?? row[1] ?? "—",
  count: row.count ?? row.count_1 ?? row[0] ?? 0,
});

const Stats = ({ embedded = false }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserStats();
  }, []);

  const getUserStats = async () => {
    try {
      const response = await apiService.getStats();
      setStats(response);
    } finally {
      setLoading(false);
    }
  };

  const provinces = stats?.data?.province?.map(normalizeProvince) ?? [];
  const total = provinces.reduce((sum, p) => sum + p.count, 0);
  const verifiedCount = extractCount(stats?.data?.verified);
  const loginCount = extractCount(stats?.data?.login);

  const content = (
      <div className="stats-card">
        <div className="stats-header">
          <h1 className="stats-title">Statistiche Utenti</h1>
          {!loading && total > 0 && (
            <span className="users-count">
              {total} {total === 1 ? "registrato" : "registrati"}
            </span>
          )}
        </div>

        {loading && <p className="stats-loading">Caricamento statistiche...</p>}

        {!loading && total === 0 && (
          <Alert variant="info">Non ci sono utenti registrati</Alert>
        )}

        {!loading && total > 0 && (
          <>
            <div className="stats-kpi-grid">
              <div className="stats-kpi stats-kpi--primary">
                <span className="stats-kpi-label">Utenti totali</span>
                <span className="stats-kpi-value">{total}</span>
              </div>
              <div className="stats-kpi">
                <span className="stats-kpi-label">Email verificata</span>
                <span className="stats-kpi-value">{verifiedCount}</span>
                <span className="stats-kpi-sub">
                  {total > 0
                    ? `${Math.round((verifiedCount / total) * 100)}% del totale`
                    : ""}
                </span>
              </div>
              <div className="stats-kpi">
                <span className="stats-kpi-label">Hanno effettuato l'accesso</span>
                <span className="stats-kpi-value">{loginCount}</span>
                <span className="stats-kpi-sub">
                  {total > 0
                    ? `${Math.round((loginCount / total) * 100)}% del totale`
                    : ""}
                </span>
              </div>
            </div>

            <h2 className="stats-section-title">Utenti per provincia</h2>
            <div className="stats-province-list">
              {[...provinces]
                .sort((a, b) => b.count - a.count)
                .map((provincia) => {
                  const pct = total > 0 ? (provincia.count / total) * 100 : 0;
                  return (
                    <div
                      className="stats-province-row"
                      key={provincia.name}
                    >
                      <div className="stats-province-info">
                        <p className="stats-province-name">{provincia.name}</p>
                        <div className="stats-province-bar-track">
                          <div
                            className="stats-province-bar-fill"
                            style={{ width: `${pct}%` }}
                          />
                        </div>
                      </div>
                      <div className="stats-province-count">
                        <span className="stats-province-number">
                          {provincia.count}
                        </span>
                        <span className="stats-province-pct">
                          {pct.toFixed(1)}%
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
          </>
        )}
      </div>
  );

  if (embedded) {
    return content;
  }

  return <div className="stats-page">{content}</div>;
};

export default Stats;
